<template>
    <div class="form-field form-scopes" :rel="name">
        <div class="form-label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">

                <label v-if="defaultScope && $store.getters.scopes[defaultScope]">
                    <input type="checkbox" checked="checked" disabled="disabled"/>
                    <span>
                        <span class="color" v-bind:style="{background: $store.getters.scopes[defaultScope].color}">
                            <i class="icon icon-locked"></i>
                        </span> {{ $store.getters.scopes[defaultScope].name }}
                    </span>
                </label>

                <label v-for="id in options" v-if="id != defaultScope && $store.getters.scopes[id]">
                    <input type="checkbox" v-model="internalValue.scopes" :value="id"/>
                    <span><span class="color" v-bind:style="{background:$store.getters.scopes[id].color}"><i class="icon icon-icon_check"></i></span> {{ $store.getters.scopes[id].name }}</span>
                </label>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormField',
        props: ['value','label','name','placeholder', 'default','callback'],
        data: function () {
            return {
                internalValue: '',
                options: [],
                defaultScope: null
            }
        },
        created: function() {
            this.internalValue = this.value
            this.options = this.$store.getters.scopes[this.$store.getters.scope.id].children
            this.isMultiple = true;
            this.onChange = this.callback ? true : false;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.internalValue.scopes = this.internalValue.scopes ? this.internalValue.scopes : []
            },
            'default'(newVal, oldVal) {
                if( newVal && this.options){
                    for (let item of this.options) {
                        if( item.id && item.id.toString().toLowerCase() == newVal.toString().toLowerCase() ){
                            this.internalValue = item;
                        }
                    }
                }
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
                this.defaultScope = newVal.scope_id ? newVal.scope_id : this.$store.getters.scope.id
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Scopes.vue